import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { LookupValueFormatter, FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { ah, ReduxWrapper, compose } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export class ComboBoxClassPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      autosetComplete: false,
      optionsAvailable: false
    }
  }

  static propTypes = buildPropTypes([

  ], {
    options: pt.array,
    valueProp: pt.string,
    textProp: pt.string,
    extraDataMap: pt.oneOfType([
      pt.string,
      pt.arrayOf(pt.shape({
        Source: pt.string,
        Dest: pt.string
      })),
      pt.func
    ]),
    autosetFirstOption: pt.bool
  })

  static defaultProps = {
    valueProp: 'Value',
    textProp: 'Text',
    options: [],
    autosetFirstOption: false
  }

  componentDidMount () {
    const {
      options = []
    } = this.props
    if (options.length > 0) {
      this.setState({
        optionsAvailable: true
      })
    }
  }

  componentDidUpdate ({
    options: prevOptions = []
  }, {
    optionsAvailable: prevOptionsAvailable
  }) {
    const {
      options: currOptions = [],
      formSetFieldValue,
      meta,
      input,
      extraDataMap,
      textProp,
      valueProp,
      autosetFirstOption
    } = this.props

    const {
      optionsAvailable: currOptionsAvailable,
      autosetComplete
    } = this.state

    if (prevOptionsAvailable === false & currOptionsAvailable === true) {
      if (autosetFirstOption === true & autosetComplete === false) {
        // only auto set if initial value is null
        if (!meta.initial) {
          let firstOption = currOptions[0] || {}
          if (firstOption[valueProp]) {
            input.onChange(firstOption[valueProp])

            if (extraDataMap) {
              let extraData = firstOption.ExtraData || {}
              if (_.isString(extraDataMap)) {
                // just set this field to the Text of the selected value
                formSetFieldValue(meta.form, extraDataMap, firstOption[textProp])
              } else if (_.isArray(extraDataMap)) {
                for (var mapInfo of extraDataMap) {
                  if (_.has(extraData, mapInfo.Source)) {
                    formSetFieldValue(meta.form, mapInfo.Dest, extraData[mapInfo.Source])
                  }
                }
              } else if (_.isFunction(extraDataMap)) {
                extraDataMap(firstOption, extraData, (field, value) => {
                  console.log({ firstOption })
                  formSetFieldValue(meta.form, field, value, 'set')
                })
              } else {
                throw Error('Invalid extraDataMap, must be a string, array, or function!')
              }
            }
          }
        }
        this.setState({
          autosetComplete: true
        })
      }
    }

    if (prevOptions.length === 0 & currOptions.length > 0) {
      if (currOptionsAvailable === false) {
        this.setState({
          optionsAvailable: true
        })
      }
    }
  }

  onChange (event) {
    const { input: { onChange }, formSetFieldValue, meta: { form }, extraDataMap, options, textProp, valueProp } = this.props

    onChange(event.target.value)

    if (extraDataMap) {
      let foundOption = _.find(options, (o) => { return o[valueProp] === event.target.value })

      if (foundOption) {
        let extraData = foundOption.ExtraData || {}
        if (_.isString(extraDataMap)) {
          // just set this field to the Text of the selected value
          formSetFieldValue(form, extraDataMap, foundOption[textProp])
        } else if (_.isArray(extraDataMap)) {
          for (var mapInfo of extraDataMap) {
            if (_.has(extraData, mapInfo.Source)) {
              formSetFieldValue(form, mapInfo.Dest, extraData[mapInfo.Source])
            }
          }
        } else if (_.isFunction(extraDataMap)) {
          extraDataMap(foundOption, extraData, (field, value) => {
            formSetFieldValue(form, field, value, 'set')
          })
        } else {
          throw Error('Invalid extraDataMap, must be a string, array, or function!')
        }
      }
    }
  }

  renderOptions (options, value, sideEffects) {
    const { valueProp, textProp } = this.props

    return _.map(options, (o, i) => {
      const valuePropValue = o[valueProp || 'Value']
      const textPropValue = o[textProp || 'Text']

      return (
        <option key={valuePropValue} value={valuePropValue}>{textPropValue || valuePropValue}</option>
      )
    })
  }

  render () {
    const { options, valueProp, textProp, groupButton, groupLabel, ...rest } = this.props
    const { optionsAvailable } = this.state
    return (
      <FieldLayoutBox {...rest}>
        {({ testId, showError, value, onChange, name, placeHolder, loading, readonly, sideEffects }) => {
          let i

          if (optionsAvailable === true) {
            if (readonly) {
              i = <input data-tid={testId} type='text' readOnly name={`static${name}`} id={`static${name}`}
                className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}
                value={LookupValueFormatter(options, value).Text} />
            } else {
              i = <select data-tid={testId} value={value} invalid={showError} name={`combo${name}`}
                id={`combo${name}`} placeholder={placeHolder} onChange={this.onChange.bind(this)} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}>
                {this.renderOptions(options, value, sideEffects)}
              </select>
            }
          } else {
            i = <input data-tid={testId} type='text' readOnly name={`comboloading${name}`} id={`comboloading${name}`} value={'loading...'}
              className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} />
          }

          return <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
            {i}
          </FieldLayoutGroup>
        }}
      </FieldLayoutBox>
    )
  }
}

const ComboBoxClass = compose(
  ReduxWrapper([

  ], [
    ah.formSetFieldValue
  ])
)(ComboBoxClassPlain)

export const ComboBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={ComboBoxClass} /> } // eslint-disable-line
export default ComboBox
